<div class="modal-header p-2">
  <h4 class="modal-title m-0">Choose Assessment Entity</h4>
</div>

<div class="modal-body">
  <ul *ngIf="assessmentAccounts.length; else noData" class="list-unstyled">
    <li *ngFor="let account of assessmentAccounts" class="mb-2">
      <a href="#" (click)="chooseAssessment(account); $event.preventDefault()" class="text-primary">
        {{ account.name }}
      </a>
    </li>
  </ul>

  <ng-template #noData>
    <p class="text-center text-muted">No assessment accounts available.</p>
  </ng-template>
</div>